module.exports = __webpack_public_path__ + "img/h3.90a32abb.png";